/**
 * AWS Amplify Configuration
 * Configures Amplify for Cognito authentication
 */

import { Amplify } from 'aws-amplify';
import config from './config';

/**
 * Get Cognito configuration from environment config
 * @returns {Object} Amplify Auth configuration
 */
export const getAmplifyConfig = () => {
  return {
    Auth: {
      Cognito: {
        userPoolId: config.cognito_user_pool_id,
        userPoolClientId: config.cognito_user_pool_client_id,
        loginWith: {
          oauth: {
            domain: config.cognito_domain,
            scopes: ['email', 'openid', 'profile', 'aws.cognito.signin.user.admin'],
            redirectSignIn: [
              `https://${config.domain}/auth/callback`,
              'http://localhost:3000/auth/callback'
            ],
            redirectSignOut: [
              `https://${config.domain}/auth/logout`,
              'http://localhost:3000/auth/logout'
            ],
            responseType: 'code',
            providers: ['Google', 'Facebook']
          },
          email: true
        }
      }
    }
  };
};

/**
 * Configure Amplify with environment-specific settings
 */
export const configureAmplify = () => {
  const amplifyConfig = getAmplifyConfig();
  Amplify.configure(amplifyConfig);
};

export default {
  getAmplifyConfig,
  configureAmplify
};
